import { render, staticRenderFns } from "./ProductDetailBelowShortDescriptionHook.vue?vue&type=template&id=17f50355&"
import script from "./ProductDetailBelowShortDescriptionHook.js?vue&type=script&lang=js&"
export * from "./ProductDetailBelowShortDescriptionHook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports